import { render, staticRenderFns } from "./Segurasp.vue?vue&type=template&id=cfa1ed3c&scoped=true"
import script from "./Segurasp.vue?vue&type=script&lang=js"
export * from "./Segurasp.vue?vue&type=script&lang=js"
import style0 from "./Segurasp.vue?vue&type=style&index=0&id=cfa1ed3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa1ed3c",
  null
  
)

export default component.exports